import clsx from "clsx";
import React from "react";
import { useTheme } from "@material-ui/core";
import { THEME_EVENT } from "@dpdgroupuk/redback-enums";
import Christmas from "./Christmas";
import Easter from "./Easter";
import Euros from "./Euros";
import Guyfawkes from "./Guyfawkes";
import Halloween from "./Halloween";
import Jubilee from "./Jubilee";
import Olympics from "./Olympics";
import Patrick from "./Patrick";
import Summer from "./Summer";
import Valentines from "./Valentines";
import Wimbledon from "./Wimbledon";
import { getVehicleImage } from "../../../../utils/images";
export const Default = ({
  vehicleTypeCode,
  className,
  style
}) => /*#__PURE__*/React.createElement("img", {
  style: style,
  className: clsx({}, className),
  src: getVehicleImage(vehicleTypeCode),
  alt: "vehicle type"
});
const THEME_ICONS = {
  [THEME_EVENT.NONE]: Default,
  [THEME_EVENT.CHRISTMAS]: Christmas,
  [THEME_EVENT.EASTER]: Easter,
  [THEME_EVENT.EUROS]: Euros,
  [THEME_EVENT.GUY_FAWKES]: Guyfawkes,
  [THEME_EVENT.HALLOWEEN]: Halloween,
  [THEME_EVENT.JUBILEE]: Jubilee,
  [THEME_EVENT.OLYMPICS]: Olympics,
  [THEME_EVENT.PATRICK]: Patrick,
  [THEME_EVENT.SUMMER]: Summer,
  [THEME_EVENT.VALENTINES]: Valentines,
  [THEME_EVENT.WIMBLEDON]: Wimbledon,
  [THEME_EVENT.PARALYMPICS]: Default
};
export default (props => {
  const {
    eventName
  } = useTheme();
  const IconComponent = THEME_ICONS[eventName] || Default;
  return /*#__PURE__*/React.createElement(IconComponent, props);
});